import React from 'react';
import AppShell from '../components/app-shell/app-shell';
import PublicShell from '../components/app-shell/public-shell';
import GetOutFreeNewsletter from '../components/landing-pages/get-our-free-newsletter';

export default function() {
  return (
    <AppShell isLandingPage>
      <PublicShell>
        <GetOutFreeNewsletter />
      </PublicShell>
    </AppShell>
  );
}
